<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'financial-finRep-custExpense',
  components: { PageTable },
}
</script>
